"use client";

import { isMedalEligibleDate } from "@dailywars/core/medals";

import { useUtcMidnightCountdown } from "#/lib/utcCountdown";

const STATUS_NOTE_CLASS = "text-center text-sm text-muted-foreground italic";

export function LeaderboardStatusNote({ mapDate, isLive }: { mapDate: string; isLive: boolean }) {
  if (!isLive) {
    return (
      <p className={STATUS_NOTE_CLASS}>
        Closed. Only scores posted on <span className="not-italic tabular-nums">{mapDate}</span>{" "}
        count.
      </p>
    );
  }

  return <LeaderboardLiveStatusNote mapDate={mapDate} />;
}

function LeaderboardLiveStatusNote({ mapDate }: { mapDate: string }) {
  const countdown = useUtcMidnightCountdown();

  return (
    <div className="flex flex-col items-center gap-1">
      <p className={STATUS_NOTE_CLASS}>
        Closes in <span className="font-semibold tabular-nums not-italic">{countdown}</span>.
      </p>
      {isMedalEligibleDate(mapDate) ? (
        <p className={STATUS_NOTE_CLASS}>
          Medals are provisional and will be finalized after leaderboard closes.
        </p>
      ) : null}
    </div>
  );
}
